import { ReactElement } from 'react';
import { LinkProps } from 'react-router';

import { ISubmitButtonLabels, SUBMIT_BUTTON_LABELS } from '@3.0/Buttons';
import { IProgressIndicatorProps } from '@components/Blackbird/Forms/ProgressIndicator/ProgressIndicator.interface';
import { WARNING_PANEL_LABELS } from 'Modules/Studio/components/StudioModal/constants/StudioModal.constants';
import { StudioModalProps } from 'Modules/Studio/components/StudioModal/StudioModal';

export type TErrorDetails = {
  code: number;
  message: string;
  additionalDetails: { [key: string]: string | any };
};

export type TWarningModalText = {
  messages: {
    primary: string | ReactElement<any>;
    secondary?: string | ReactElement<any>;
  };
  buttons: {
    primary: ISubmitButtonLabels;
    cancel?: string;
  };
};

export const WARNING_MODAL_TEXT: TWarningModalText = {
  messages: {
    primary: '',
  },
  buttons: { primary: SUBMIT_BUTTON_LABELS.ok },
};

export type TWarningModalProps = {
  text: TWarningModalText;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  hideCancelButton?: boolean;
  modalProps?: StudioModalProps;
  progressProps?: IProgressIndicatorProps;
  confirmBtnAsLink?: boolean;
  confirmBtnLinkProps?: LinkProps;
  showErrorDetails?: boolean;
  errorDetails?: TErrorDetails;
  showContinueText?: boolean;
};

export const modalPropDefaults = {
  modalName: WARNING_PANEL_LABELS.attention,
  modalWidth: '720px',
  modalHeight: 'auto',
  hideHelpBtn: true,
  showBackBtn: false,
  modalContainerProps: { 'data-testid': 'warning-modal' },
};
